import React, { FC, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { ContainerStyled, PaginacaoContainer, RoundedButton } from './style';

interface PaginationProps {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalIndications: number;
  totalPages: number;
}

const Pagination: FC<PaginationProps> = ({currentPage, setCurrentPage, totalIndications, totalPages}) => {
    const perPage = 100;
    const pageFirstIndex = currentPage * perPage - (perPage - 1);
    let pageLastIndex = currentPage * perPage;
    if (pageLastIndex > totalIndications) {
        pageLastIndex = totalIndications;
    }

    return (
        <ContainerStyled className="actions-buttons">
      {currentPage > 0 && (
        <PaginacaoContainer>
          <span>
            {pageFirstIndex}-{pageLastIndex} de {totalIndications}
          </span>
          <RoundedButton disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </RoundedButton>

          <RoundedButton disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
            <FontAwesomeIcon icon={faChevronRight} />
          </RoundedButton>
        </PaginacaoContainer>
      )}
    </ContainerStyled>
    )
}
export default Pagination;